const { styled, Badge } = require("@mui/material")

const OnlineBadge = styled(Badge, { shouldForwardProp: (prop) => prop !== "isOnline", })(({ theme, isOnline }) => ({
  "& .MuiBadge-badge": {
    width: 10,
    height: 10,
    borderRadius: 10,
    color: isOnline ? theme.palette.green[500] : theme.palette.text.disabled,
    backgroundColor: isOnline ? theme.palette.green[500] : theme.palette.text.disabled,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": isOnline ? {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: "''",
    } : {},
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(1.5)",
      opacity: 0,
    },
  },
}))

export default OnlineBadge